import React from 'react'
import { Divider } from 'antd'
import Utils from '../../../../utils/Utils'
import { getTicketPrintStyle } from '../../../../utils/ticketPrintStyle'
import { deriveSerieNumero } from '../../../../utils/felSerieNumero'

export const VentaTicketFactura = React.forwardRef((props, ref) => {
  const { getSell } = props

  function trunc(x, decimalDigits = 2, returnText = true, longFixed = true) {
    x = Number(x);
    decimalDigits = Number(decimalDigits);

    x = x * (10 ** decimalDigits);
    x = x - x % 1;
    x = x / (10 ** decimalDigits);

    if (returnText)
      if (longFixed)
        return x.toFixed(decimalDigits);
      else
        return x.toString();
    else
      return x;
  }

  function formatTaxPercentage(value) {
    if (value === undefined || value === null || value === '') return ''
    const percentage = Number(value) * 100
    return Number.isInteger(percentage) ? percentage.toString() : percentage.toFixed(2)
  }

  let auxDate = getSell.dateAux
  if (!getSell.dateAux) {
    auxDate = Utils.formatDateTime(new Date(getSell?.date))
  }

  const date = auxDate

  let flag = false
  if (getSell?.notes) {
    JSON.parse(getSell?.notes).forEach(element => {
      if (element) flag = true
    });
  }

  const currency = getSell.store.company.currency.symbol
  const pago = getSell?.sell_payment?.payment_method?.name

  const { fontSize, titleFontSize } = getTicketPrintStyle(getSell?.store?.ticket_print_width)
  const ticketLogo = getSell?.store?.company?.ticket_logo
  const isHonduras = getSell.store.company.country.name === 'Honduras'
  const fel = getSell?.store?.company?.fel
  const certifiedDte = getSell?.dtes?.find(d => d.certifier_success && !d.is_cancellation)
  const serieNumero = deriveSerieNumero(certifiedDte?.uuid)

  const lineStyle = { fontSize, fontWeight: 400, margin: '2px 0' }
  const boldLineStyle = { fontSize, fontWeight: 700, margin: '2px 0' }
  const sectionTitleStyle = { fontSize: fontSize + 2, fontWeight: 700, margin: '4px 0' }
  const metaRow = { display: 'flex', justifyContent: 'space-between', margin: '2px 0', gap: 8, textAlign: 'left' }
  const dashedDivider = <div style={{ borderTop: '1px dashed #999', margin: '10px 1rem' }} />

  return (
    <div ref={ref} data-print-width={getSell?.store?.ticket_print_width} style={{ textAlign: 'center', fontSize }} className='ticket-modal thermal-ticket'>
      <br />
      {ticketLogo && <img src={ticketLogo} alt={getSell?.store?.company?.name} style={{ maxWidth: '100%', maxHeight: '90px' }} />}
      <br />
      {isHonduras ? (
        <>
          <h1 style={{ color: 'var(--tendero-green)', fontSize: titleFontSize }}>Factura</h1>
          {
            getSell?.sell_invoice?.fel_hondura ?
              <>
                <p style={boldLineStyle}>{getSell?.store?.company?.name}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.rtn}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.reason}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.tradename}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.address}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.phone}</p>
                <p style={lineStyle}>{getSell?.sell_invoice?.fel_hondura.email}</p>
              </> :
              <>
                <p style={boldLineStyle}>{getSell?.store?.company?.name}</p>
                <p style={lineStyle}>{`NIT: ${getSell?.store?.company?.nit}`}</p>
                <p style={lineStyle}>{getSell?.store?.company?.address}</p>
              </>
          }
          <p style={lineStyle}>{getSell?.store?.name}</p>
          <br></br>
          <div style={metaRow}>
            <span style={lineStyle}>{`Serie: ${getSell?.sell_invoice?.series}`}</span>
            <span style={lineStyle}>{`Correlativo: ${getSell?.sell_invoice?.internal_correlative}`}</span>
          </div>
          <div style={metaRow}>
            <span style={lineStyle}>{date}</span>
            <span style={lineStyle}>{`Ticket No. ${getSell?.sell_invoice?.invoice}`}</span>
          </div>
        </>
      ) : (
        <>
          <p style={{ ...boldLineStyle, fontSize: fontSize + 1 }}>{getSell?.store?.company?.name}</p>
          <p style={lineStyle}>{`NIT: ${getSell?.store?.company?.nit}`}</p>
          <p style={lineStyle}>{getSell?.store?.company?.address}</p>
          <p style={lineStyle}>{getSell?.store?.name}</p>
          {(getSell?.store?.company?.subject_quarterly_isr || getSell?.store?.company?.iva_retention_agent) && (
            <div style={{ marginTop: 10 }}>
              {getSell?.store?.company?.subject_quarterly_isr && <p style={lineStyle}>{'** Sujeto a pagos trimestrales ISR **'}</p>}
              {getSell?.store?.company?.iva_retention_agent && <p style={lineStyle}>{'** Agente de Retención del IVA **'}</p>}
            </div>
          )}
          {dashedDivider}
          {certifiedDte ? (
            <>
              <p style={sectionTitleStyle}>DOCUMENTO TRIBUTARIO ELECTRÓNICO</p>
              <p style={sectionTitleStyle}>FACTURA</p>
              {certifiedDte?.uuid && (
                <>
                  <p style={{ ...lineStyle, marginTop: 6 }}>Número de Autorización:</p>
                  <p style={{ ...lineStyle, wordBreak: 'break-all' }}>{certifiedDte.uuid}</p>
                </>
              )}
              {serieNumero && (
                <div style={metaRow}>
                  <span style={lineStyle}>{`Serie: ${serieNumero.serie}`}</span>
                  <span style={lineStyle}>{`Número: ${serieNumero.numero}`}</span>
                </div>
              )}
              <p style={lineStyle}>{`Fecha de Emisión: ${date}`}</p>
              {fel?.nombre_certificador && (
                <p style={{ ...lineStyle, fontSize: Math.max(9, fontSize - 2), marginTop: 6 }}>{`Certificador: ${fel.nombre_certificador}`}</p>
              )}
              {fel?.nit_certificador && (
                <p style={{ ...lineStyle, fontSize: Math.max(9, fontSize - 2) }}>{`NIT Certificador: ${fel.nit_certificador}`}</p>
              )}
              {fel?.regimen_certificador && (
                <p style={{ ...lineStyle, fontSize: Math.max(9, fontSize - 2) }}>{`Régimen Certificador: ${fel.regimen_certificador}`}</p>
              )}
            </>
          ) : getSell?.access_number ? (
            <>
              <p style={sectionTitleStyle}>DOCUMENTO EN CONTINGENCIA</p>
              <p style={sectionTitleStyle}>FACTURA</p>
              <p style={{ ...lineStyle, marginTop: 6 }}>Número de acceso:</p>
              <p style={{ ...boldLineStyle, fontSize: fontSize + 2 }}>{getSell.access_number}</p>
              <p style={lineStyle}>{`Fecha: ${date}`}</p>
            </>
          ) : (
            <>
              <p style={sectionTitleStyle}>{getSell?.store?.company?.ticket_title || 'TICKET DE VENTA'}</p>
              <div style={metaRow}>
                <span style={lineStyle}>{date}</span>
                <span style={lineStyle}>{`Ticket No. ${getSell?.sell_invoice?.invoice}`}</span>
              </div>
            </>
          )}
        </>
      )}

      {dashedDivider}
      <div style={metaRow}>
        <span style={lineStyle}>Atendió:</span>
        <span style={lineStyle}>{getSell?.seller?.name}</span>
      </div>
      <div style={metaRow}>
        <span style={lineStyle}>Fecha:</span>
        <span style={lineStyle}>{date}</span>
      </div>
      <div style={metaRow}>
        <span style={lineStyle}>Turno:</span>
        <span style={lineStyle}>{getSell?.store_turn_id}</span>
      </div>
      <div style={metaRow}>
        <span style={lineStyle}>Cliente:</span>
        <span style={lineStyle}>{getSell?.client?.name}</span>
      </div>
      <div style={metaRow}>
        <span style={lineStyle}>NIT:</span>
        <span style={lineStyle}>{getSell?.client?.nit}</span>
      </div>
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <div style={{ padding: 0 }}>
        <table className='ticket-modal' style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
          <colgroup>
            <col style={{ width: '55%' }} />
            <col style={{ width: '20%' }} />
            <col style={{ width: '25%' }} />
          </colgroup>
          <thead>
            <tr style={{ ...boldLineStyle, fontSize: fontSize - 2 }}>
              <td style={{ textAlign: 'left' }}>Descripción</td>
              <td style={{ textAlign: 'center' }}>Cant.</td>
              <td style={{ textAlign: 'right' }}>Total</td>
            </tr>
          </thead>
          <tbody>
            {(() => {
              const details = getSell?.sell_details || []
              const sorted = [...details].sort((a, b) => (a.item_line ?? 0) - (b.item_line ?? 0))

              // En el ticket el cliente solo necesita el nombre del combo y lo extra que pagó,
              // no cada presentación que ya venía incluida (eso sí se detalla en la comanda).
              const comboGroups = []
              const comboGroupByInstance = {}
              const looseItems = []
              sorted.forEach((data) => {
                if (!data.combo_instance_id) {
                  looseItems.push(data)
                  return
                }
                let group = comboGroupByInstance[data.combo_instance_id]
                if (!group) {
                  group = { instanceId: data.combo_instance_id, name: '', items: [], extras: [] }
                  comboGroupByInstance[data.combo_instance_id] = group
                  comboGroups.push(group)
                }
                if (data.presentation_combo?.description && !group.name) {
                  group.name = data.presentation_combo.description
                }
                if (data.is_combo_extra) group.extras.push(data)
                else group.items.push(data)
              })

              const subtotalOf = (rows) => rows.reduce((acc, r) => acc + Number(r.sub_total || 0), 0)

              const renderRow = (key, description, quantity, subtotal, indent) => (
                <tr key={key} style={{ fontSize, fontWeight: 400, pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                  <td style={{ textAlign: 'left', textTransform: 'none', wordBreak: 'break-word', paddingRight: 6, paddingLeft: indent ? 12 : 0 }}>
                    {description}
                  </td>
                  <td style={{ textAlign: 'center' }}>{quantity}</td>
                  <td style={{ textAlign: 'right' }}>{`${currency} ${trunc(subtotal)}`}</td>
                </tr>
              )

              return (
                <>
                  {comboGroups.map((group) => {
                    const itemsSubtotal = subtotalOf(group.items)
                    const hasExtras = group.extras.length > 0
                    return (
                      <React.Fragment key={group.instanceId}>
                        {renderRow(group.instanceId, `Combo: ${group.name}`, 1, itemsSubtotal, false)}
                        {hasExtras && (
                          <>
                            <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                              <td colSpan={3} style={{ textAlign: 'left', fontWeight: 700, fontStyle: 'italic', fontSize: fontSize - 2, paddingLeft: 12, paddingTop: 4 }}>
                                {'Extra:'}
                              </td>
                            </tr>
                            {group.extras.map((data) => renderRow(data.id, data?.presentation?.description, data.quantity, data.sub_total, true))}
                            <tr style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                              <td colSpan={2} style={{ textAlign: 'left', fontWeight: 700, fontSize, paddingLeft: 12, borderTop: '1px solid #999' }}>
                                {'Sub total:'}
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: 700, fontSize, borderTop: '1px solid #999' }}>
                                {`${currency} ${trunc(itemsSubtotal + subtotalOf(group.extras))}`}
                              </td>
                            </tr>
                          </>
                        )}
                      </React.Fragment>
                    )
                  })}
                  {looseItems.map((data) => renderRow(data.id, data?.presentation?.description, data.quantity, data.sub_total, false))}
                </>
              )
            })()}
          </tbody>
        </table>
      </div>
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <div style={metaRow}>
        <span style={lineStyle}>{'Total artículos: '}{getSell?.sell_details?.reduce((acumulador, actual) => acumulador + parseInt(actual.quantity), 0)}</span>
        <span style={boldLineStyle}>{'Total: '}{currency} {trunc(getSell?.total)}</span>
      </div>
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />

      <div>
        <table className='ticket-modal' style={{ width: '-webkit-fill-available' }}>
          <tbody>
            {pago === 'CASH' &&
              <tr key={0} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'Pago en efectivo:'}</td>
                <td style={{ marginRight: '1rem' }}>{pago === 'CASH' ? `${currency} ` : ''}{pago === 'CASH' ? trunc(getSell?.sell_payment?.amount) : 'xxx'}</td>
              </tr>
            }
            {pago === 'CARD' &&
              <tr key={1} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'Pago en tarjeta:'}</td>
                <td style={{ marginRight: '1rem' }}>{pago === 'CARD' ? `${currency} ` : ''} {pago === 'CARD' ? trunc(getSell?.sell_payment?.amount) : 'xxx'}</td>
              </tr>
            }
            {pago === 'CREDIT' &&
              <tr key={2} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'Credito/Fiado:'}</td>
                <td style={{ marginRight: '1rem' }}>{pago === 'CREDIT' ? `${currency} ` : ''} {pago === 'CREDIT' ? trunc(getSell?.sell_payment?.amount) : 'xxx'}</td>
              </tr>
            }
            {pago !== 'CASH' && pago !== 'CARD' && pago !== 'CREDIT' &&
              <tr key={3} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{pago}:</td>
                <td style={{ marginRight: '1rem' }}>{`${currency} ${trunc(getSell?.sell_payment?.amount)}`}</td>
              </tr>
            }
            <br />
            <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
            <br />
            <tr key={4} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
              <td style={{ marginLeft: '1rem' }}>{'Dto o rebaja:'}</td>
              <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.discount_amount)}</td>
            </tr>
            <tr key={5} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
              <td style={{ marginLeft: '1rem' }}>{'Monto exonerado:'}</td>
              <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.exonerated_amount)}</td>
            </tr>
            <tr key={6} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
              <td style={{ marginLeft: '1rem' }}>{'Monto exento: '}</td>
              <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.exempt_amount)}</td>
            </tr>
            {isHonduras ? (
              <>
                <tr key={7} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                  <td style={{ marginLeft: '1rem' }}>{`Importe al ${formatTaxPercentage(getSell?.sell_invoice?.percentage_amount_taxed)}%:`}</td>
                  <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.value_amount_taxed)}</td>
                </tr>
                <tr key={8} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                  <td style={{ marginLeft: '1rem' }}>{`Isv al ${formatTaxPercentage(getSell?.sell_invoice?.percentage_amount_taxed)}%:`}</td>
                  <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.amount_iva)}</td>
                </tr>
              </>
            ) : (
              <tr key={9} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{`Impuesto ${formatTaxPercentage(getSell?.sell_invoice?.percentage_amount_taxed)}%:`}</td>
                <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell?.sell_invoice?.amount_iva)}</td>
              </tr>
            )}
            {isHonduras && (
              <>
                <tr key={10} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                  <td style={{ marginLeft: '1rem' }}>{`Importe al 18%:`}</td>
                  <td style={{ marginRight: '1rem' }}>{currency} {'0.00'}</td>
                </tr>
                <tr key={11} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                  <td style={{ marginLeft: '1rem' }}>{'Isv al 18%'}</td>
                  <td style={{ marginRight: '1rem' }}>{currency} {'0.00'}</td>
                </tr>
              </>
            )}
            {getSell.sell_invoice.exonerated_client === 1 &&
              <tr key={12} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 700 }}>
                <td style={{ marginLeft: '1rem' }}>{'Gran total:'}</td>
                <td style={{ marginRight: '1rem' }}>{currency} {trunc(parseFloat(getSell?.sell_invoice?.value_amount_taxed) + parseFloat(getSell?.sell_invoice?.amount_iva))}</td>
              </tr>
            }

            <tr key={13} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 700 }}>
              <td style={{ marginLeft: '1rem' }}>{'Total pagado:'}</td>
              <td style={{ marginRight: '1rem' }}>{currency} {trunc(getSell.total)}</td>
            </tr>
          </tbody>
        </table>
      </div >
      {
        getSell?.sell_invoice?.fel_hondura &&
        <>
          <br />
          <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
          <br />
          <table className='ticket-modal' style={{ width: '-webkit-fill-available' }}>
            <tbody>
              <tr key={0} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'C.a.i.:'}</td>
                <td style={{ marginRight: '1rem' }}>{getSell?.sell_invoice?.fel_hondura?.cai.toUpperCase()}</td>
              </tr>
              <tr key={1} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'Rango autorizado:'}</td>
                <td style={{ marginRight: '1rem' }}>{`${getSell?.store?.codigo_establecimiento.toString().padStart(3, 0)}-${getSell?.sell_invoice?.fel_hondura.establishment_taxpayer.toString().padStart(3, 0)}-${getSell?.sell_invoice?.fel_hondura.document_type}-${getSell?.sell_invoice?.fel_hondura?.start_authorized_range.toString().padStart(8, 0)} a la ${getSell?.sell_invoice?.fel_hondura?.end_authorized_range.toString().padStart(8, 0)}`}</td>
              </tr>
              <tr key={2} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{'Fecha limite de emision:'}</td>
                <td style={{ marginRight: '1rem' }}>{`${getSell?.sell_invoice?.fel_hondura?.emission_limit_date}`}</td>
              </tr>
              <tr key={3} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                <td style={{ marginLeft: '1rem' }}>{`${getSell?.sell_invoice?.fel_hondura?.denomination}`}</td>
                <td style={{ marginRight: '1rem' }}>{`${getSell?.store?.codigo_establecimiento.toString().padStart(3, 0)}-${getSell?.sell_invoice?.fel_hondura.establishment_taxpayer.toString().padStart(3, 0)}-${getSell?.sell_invoice?.fel_hondura.document_type}-${getSell?.sell_invoice?.invoice_correlative_number.toString().padStart(8, 0)}`}</td>
              </tr>
              {((window.convertir.NumerosALetras(getSell.total.toUpperCase())).slice(0, -17)).length > 50 ? (
                <>
                  <tr key={4} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                    <td style={{ marginLeft: '1rem' }}>{'Total en letras: '}</td>
                  </tr>
                  <tr key={4} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                    <td style={{ marginRight: '1rem' }}>{((window.convertir.NumerosALetras(getSell.total.toUpperCase())).slice(0, -17))}</td>
                  </tr>
                </>
              ) : (
                <tr key={4} style={{ display: 'flex', justifyContent: 'space-between', fontSize, fontWeight: 400 }}>
                  <td style={{ marginLeft: '1rem' }}>{'Total en letras: '}</td>
                  <td style={{ marginRight: '1rem' }}>{((window.convertir.NumerosALetras(getSell.total.toUpperCase())).slice(0, -17))}</td>
                </tr>
              )}
              <tr key={6} style={{ display: 'flex', fontSize, fontWeight: 400, justifyContent: 'center' }}>
                <td style={{ marginLeft: '1rem' }}>{'Original: Cliente - Copia: Emisor'}</td>
              </tr>
            </tbody>
          </table>
        </>
      }
      {
        getSell.description && (
          <>
            <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <p style={{ ...lineStyle, marginLeft: '1rem' }}>Descripción: {getSell.description}</p>
            </div>
          </>
        )
      }
      {
        flag ? (
          <>
            <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
            <div style={{ textAlign: 'initial', marginLeft: '2rem' }} className='ticket-modal'>
              <p style={boldLineStyle}>{'Informaciones Adicionales:'}</p>
              {getSell?.notes && JSON.parse(getSell?.notes).map((data, i) =>
                data ? <p key={i} style={lineStyle}>{`Nota ${i + 1}: ${data}`}</p> : null
              )}
            </div>
          </>
        ) : (
          <></>
        )
      }
      {!certifiedDte && getSell?.access_number && (
        <>
          {dashedDivider}
          <p style={{ ...lineStyle, margin: '0 1.5rem' }}>{'Emisión en contingencia, obtenga su DTE certificado en el sitio www.sat.gob.gt/fel.'}</p>
        </>
      )}
      {getSell?.store?.company?.ticket_legend && (
        <>
          {dashedDivider}
          <p style={{ ...lineStyle, fontStyle: 'italic', margin: '0 1.5rem' }}>{getSell.store.company.ticket_legend}</p>
        </>
      )}
      <br />
    </div >
  );
});
